export default {
  whatsappProfile:{
    about: '',
    email: '',
    address: '',
    websites: [''],
    vertical: '',
    description: '',
    messaging_product: 'whatsapp',
    profile_picture_url: 'https://cdn.onlinewebfonts.com/svg/img_131793.png'
  }
}
